import { render, staticRenderFns } from "./FileInputs.vue?vue&type=template&id=64e68e4a"
import script from "./FileInputs.vue?vue&type=script&lang=js"
export * from "./FileInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports